(function () {
  'use strict';

  if (window.__nestMobileMenuScrollPreserve20260831) return;
  window.__nestMobileMenuScrollPreserve20260831 = 'v3-targeted-state-conditional-restore';

  var mobileQuery = window.matchMedia('(max-width: 1020px)');
  var toggleSelector = '.js-mobile-nav-toggle';
  var drawerSelector = '.mobile-menu-wrapper';
  var closeSelector = '.mobile-menu-close';
  var savedScroll = null;
  var opener = null;
  var returnFocus = false;
  var skipNextRestore = false;
  var wasOpen = false;
  var restoreFrame = 0;
  var settledTimer = 0;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function toggle() {
    return document.querySelector(toggleSelector);
  }

  function drawer() {
    return document.querySelector(drawerSelector);
  }

  function currentScroll() {
    return {
      x: window.scrollX || window.pageXOffset || 0,
      y: window.scrollY || window.pageYOffset || 0
    };
  }

  function isOpen() {
    if (!mobileQuery.matches) return false;
    var control = toggle();
    var panel = drawer();
    if (!control || !panel) return false;

    return control.getAttribute('aria-expanded') === 'true' ||
      control.classList.contains('mobile-nav--close') ||
      panel.style.display === 'block';
  }

  function clearPendingRestore() {
    if (restoreFrame) {
      window.cancelAnimationFrame(restoreFrame);
      restoreFrame = 0;
    }
    if (settledTimer) {
      window.clearTimeout(settledTimer);
      settledTimer = 0;
    }
  }

  function beginOpen(control, keyboard) {
    if (!mobileQuery.matches || isOpen()) return;
    clearPendingRestore();
    savedScroll = currentScroll();
    opener = control || toggle();
    returnFocus = !!keyboard;
    skipNextRestore = false;
  }

  function pointerIntent(event) {
    var target = event && event.target;
    if (!target || !target.closest) return;

    if (target.closest(closeSelector)) {
      returnFocus = false;
      return;
    }

    var control = target.closest(toggleSelector);
    if (control) beginOpen(control, false);
  }

  function keyboardIntent(event) {
    var key = event && event.key;
    if (key !== 'Enter' && key !== ' ' && key !== 'Spacebar') return;

    var target = event.target;
    var control = target && target.closest ? target.closest(toggleSelector) : null;
    if (control) beginOpen(control, true);
  }

  function movedFrom(target) {
    var current = currentScroll();
    return Math.abs(current.x - target.x) > 2 ||
      Math.abs(current.y - target.y) > 2;
  }

  function restoreIfMoved(target) {
    if (target && movedFrom(target)) {
      window.scrollTo(target.x, target.y);
    }
  }

  function finishClose() {
    var target = savedScroll;
    var focusTarget = opener;
    var shouldReturnFocus = returnFocus;
    var shouldSkip = skipNextRestore;

    savedScroll = null;
    opener = null;
    returnFocus = false;
    skipNextRestore = false;
    clearPendingRestore();

    if (!target || shouldSkip) return;

    restoreFrame = window.requestAnimationFrame(function () {
      restoreFrame = 0;

      if (shouldReturnFocus && focusTarget && focusTarget.focus) {
        try {
          focusTarget.focus({ preventScroll: true });
        } catch (error) {
          focusTarget.focus();
        }
      }

      restoreIfMoved(target);

      settledTimer = window.setTimeout(function () {
        settledTimer = 0;
        restoreIfMoved(target);
      }, 160);
    });
  }

  function syncState() {
    var open = isOpen();

    if (open) {
      if (!wasOpen) {
        if (!savedScroll) savedScroll = currentScroll();
        if (!opener) opener = toggle();
        wasOpen = true;
      }
      return;
    }

    if (wasOpen) {
      wasOpen = false;
      finishClose();
    }
  }

  function noteClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest(drawerSelector + ' a[href]');
    if (link &&
        !link.classList.contains('mobile-menu-section-header') &&
        link.getAttribute('href') &&
        link.getAttribute('href') !== '#' &&
        link.getAttribute('href').indexOf('javascript:') !== 0) {
      skipNextRestore = true;
    }

    if (target.closest(toggleSelector) || target.closest(closeSelector)) {
      window.requestAnimationFrame(syncState);
    }
  }

  function installStateObserver() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(syncState);
    var control = toggle();
    var panel = drawer();

    if (control) {
      observer.observe(control, {
        attributes: true,
        attributeFilter: ['class', 'aria-expanded']
      });
    }

    if (panel) {
      observer.observe(panel, {
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden', 'hidden']
      });
    }
  }

  function init() {
    document.addEventListener('pointerdown', pointerIntent, true);
    document.addEventListener('touchstart', pointerIntent, {
      capture: true,
      passive: true
    });
    document.addEventListener('keydown', keyboardIntent, true);
    document.addEventListener('click', noteClick, true);

    installStateObserver();

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncState);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(syncState);
    }

    window.addEventListener('pagehide', clearPendingRestore);
    syncState();
  }

  ready(init);
})();